module.exports = __webpack_public_path__ + "static/img/pic.d6cf66d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pic.png
// module id = 1063
// module chunks = 2